import {
  LBAiInsightsIcon,
  LBButton,
  LBTooltip,
  LBTooltipContent,
  LBTooltipTrigger
} from '@linearb/buzz'

import { BuyerChip, buyerEngagedLabel } from '../utils/buyerDisplay'

interface InsightsTriggerButtonProps {
  count: number
  buyerCount?: number
  size?: 'sm' | 'default' | 'lg' | 'icon'
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const InsightsTriggerButton = ({
  count,
  buyerCount = 0,
  size,
  onClick
}: InsightsTriggerButtonProps) => {
  const hasBuyer = buyerCount > 0
  const button = (
    <LBButton
      size={size}
      onClick={onClick}
      className={`gap-2 cursor-pointer text-white ${
        count > 0
          ? 'bg-indigo-500 hover:bg-indigo-600'
          : 'bg-emerald-500 hover:bg-emerald-600'
      }`}
    >
      <LBAiInsightsIcon className='h-4 w-4' />
      <span>Insights</span>
      {count > 0 && <span>{count}</span>}
      <BuyerChip count={buyerCount} withSeparator={count > 0} />
    </LBButton>
  )
  if (!hasBuyer) {
    return button
  }
  return (
    <LBTooltip>
      <LBTooltipTrigger asChild>{button}</LBTooltipTrigger>
      <LBTooltipContent>{buyerEngagedLabel(buyerCount)}</LBTooltipContent>
    </LBTooltip>
  )
}

export default InsightsTriggerButton
